import { createGlobalStyle } from "styled-components";
import fontFaces from "../mixins/fontFaces";
export const FontFaces = createGlobalStyle `
  ${fontFaces};
`;
export default FontFaces;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9udEZhY2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvRm9udEZhY2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3RELE9BQU8sU0FBUyxNQUFNLHFCQUFxQixDQUFDO0FBRTVDLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBRyxpQkFBaUIsQ0FBQTtJQUN0QyxTQUFTO0NBQ1osQ0FBQztBQUVGLGVBQWUsU0FBUyxDQUFDIn0=